import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { config } from '../config/config';


@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private userPermissions: string[] = [];

  private permissionsCheckUrl = `${config.examApiBaseUrl}/auth/check-permissions`;

  constructor(private http: HttpClient, private router: Router) { }

  checkUserPermissions(email: string, accessToken: string, refreshToken: string): Observable<any> {
    const body = {
      Email: email,
      AccessToken: accessToken,
      RefreshToken: refreshToken,
    };
    return this.http.post<any>(this.permissionsCheckUrl, body, { headers: { 'Content-Type': 'application/json' }});
  }

  setUserPermissions(permissions: string[]) {
    this.userPermissions = permissions;
  }

  hasPermission(permission: string): boolean {
    return this.userPermissions.includes(permission);
  }

  getUserPermissions(): string[] {
    return this.userPermissions;
  }

  logout(): void {
    const accessToken = sessionStorage.getItem('accessToken');

    if (accessToken) {
      this.http.post(
        'https://graph.microsoft.com/v1.0/me/revokeSignInSessions',
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      ).subscribe({
        next: () => console.log('Sessions revoked'),
        error: (err) => console.error('Revoke failed:', err)
      });
    }

    this.userPermissions = [];
    sessionStorage.clear();
    this.router.navigate(['/']);
  }
}
